export const splitCamelCase = (input: string) => {
  return input
    .split('_')
    .join(' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
}
